// extracted by mini-css-extract-plugin
export default {"StickyBlock":"bet_a bht_bj"};